import { G2ComparisonType } from '../components/G2Comparison'
import { AlternativeType } from '../types'
import ParagonLogo from './images/paragon-logo.svg'
import ParagonIcon from './images/paragon-icon.svg'

export const linkToG2 =
  'https://www.g2.com/compare/integration-app-vs-useparagon'
export const g2Comparison: G2ComparisonType = {
  name: 'Paragon',
  logo: ParagonLogo.src,
  stars: 4.5,
  reviews: 68,
  markerSegment: (
    <>
      <b>Small-Business</b> (82.1% of reviews)
    </>
  ),
  entryLevelPricing: (
    <>
      <b>Free Trial</b>
    </>
  ),
}
export const alternative: AlternativeType = {
  name: 'Paragon',
  logo: ParagonLogo,
  icon: ParagonIcon,
  comparison_table: {
    non_developer_support: 'Drag-and-drop workflow builder',
    developer_support: 'Limited to connections, users, and task history',
    on_premise_option: true,
    end_user_ui: 'Iframe with custom styles',
    connector_library: '~150',
    custom_connectors: 'Partially supported (Auth + pass-through API only)',
  },
}
